
import { Box } from "@mui/material";
import { CheckCircle, Cancel, HourglassEmpty, AssignmentTurnedIn, RateReview, ThumbUp, ThumbDown, Paid } from "@mui/icons-material";

const StatusButton = ({ statusData }) => {
    const statusClassMap = {
        1: "submitted",
        2: "workscope-in-review",
        3: "approved",
        4: "rejected",
        5: "workscope-approved",
        6: "workscope-rejected",
        7: "in-review",
        8: "paid"
    };
    const statusClass = statusClassMap[statusData?.value]
    const statusStyleMap = {
          submitted: {
            color: "#0175ff",
            bg: "linear-gradient(90deg,#bedbfd,#dcebfc 95%)",
            border: "#8c9dff",
          },

        "in-review": {
            bg: "linear-gradient(90deg, #f4c430, #fde68a 95%)",
            border: "#d4a017",
            color: "#5c3d00"
        },

        approved: {
            bg: "linear-gradient(90deg, #beed87, #d2e9b6 95%)",
            border: "#5ec364",
            color: "#2e7d32"
        },
        "workscope-approved": {
            bg: "linear-gradient(90deg, #d4f57c, #ecf8c6 95%)",
            border: "#8bc34a",
            color: "#33691e"
        },

        "workscope-in-review": {
            bg: "linear-gradient(90deg, #ffe082, #fff3cd 95%)",
            border: "#ffb300",
            color: "#6d4c00"
        },
        rejected: {
            color: "#d32f2f",
            bg: "linear-gradient(269deg,#fcd5d5,#fca8a8 95%)",
            border: "#ce4343",
        },
        "workscope-rejected": {
            color: "#d32f2f",
            bg: "linear-gradient(269deg,#fcd5d5,#fca8a8 95%)",
            border: "#ce4343",
        },
        paid: {
            bg: "linear-gradient(90deg, #b3d4fc, #d6e9fd 95%)",
            border: "#1565c0",
            color: "#0d47a1"
        }

    };
    const statusIconMap = {
        submitted: AssignmentTurnedIn,
        "workscope-in-review": HourglassEmpty,
        approved: CheckCircle,
        rejected: Cancel,
        "workscope-approved": ThumbUp,
        "workscope-rejected": ThumbDown,
        "in-review": HourglassEmpty,
        paid: Paid
    };
    const style = statusStyleMap[statusClass] || {};
    const IconComponent = statusIconMap[statusClass];
    return (
        <Box className="status" sx={{ ml: 0 }}>
            <Box
                className={`status-btn ${statusClass}`}
                sx={{ background: style.bg, border: ` ${style.border}`, color: `${style.color} !important`, px: 1, borderRadius: "6px", fontSize: "12px", fontWeight: 500, boxShadow: "0 1px 2px rgba(0,0,0,0.08)" }}
                style={{ marginTop: "0px", display: "inline-flex", alignItems: "center", justifyContent: statusClass === "paid" ? "center" : "flex-start", height: "22px", width: statusClass === "paid" ? "70px" : "fit-content", whiteSpace: "nowrap" }}
            >
                {IconComponent && (
                    <IconComponent
                        style={{
                            fontSize: "16px",
                            marginRight: "4px",
                            verticalAlign: "middle",
                            color: style.color || "#000"
                        }}
                    />
                )}
                {statusData?.label || "--"}
            </Box>
        </Box>
    )
}

export default StatusButton